// extracted by mini-css-extract-plugin
export default {"content":"HeaderEmail_content__pq5ck","title":"HeaderEmail_title__m0wqC","text":"HeaderEmail_text__z5gl1","img":"HeaderEmail_img__B5Qio","button":"HeaderEmail_button__LvXkD"};